import { Link } from 'react-router-dom';

export default function TeaCampaignBanner() {
  return (
    <section className="py-12 sm:py-16 bg-gradient-to-br from-[#FFF5F2] via-[#FFF8F5] to-[#FFFAF7]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/60 backdrop-blur-sm rounded-full mb-4 border border-[#C4787A]/10">
          <span className="text-base" aria-hidden="true">🌸</span>
          <span className="text-xs sm:text-sm font-light text-black/70 tracking-[0.15em]">期間限定</span>
        </div>
        
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-extralight text-black mb-3 tracking-[0.08em]">
          新生活応援キャンペーン
        </h2>
        <p className="text-sm sm:text-base font-extralight text-black/60 mb-6 tracking-wide max-w-2xl mx-auto">
          2026年3月1日より価格改定。<br className="sm:hidden" />
          3月31日までのご予約で現行価格を維持 + Amazonギフト券5,000円
        </p>

        <Link
          to="/campaign"
          className="inline-flex items-center gap-2 px-8 py-3 bg-black text-white text-sm font-light tracking-[0.08em] hover:bg-black/80 transition-colors whitespace-nowrap rounded-md cursor-pointer"
        >
          キャンペーン詳細を見る
          <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
        </Link>
      </div>
    </section>
  );
}
